<template>
    <div class="search-item mb-4 mb-md-5 pb-3 pb-md-4">
        <router-link :to="item.router">
            <div class="search-item__title mb-1 mb-md-2">
                <span>{{item.type}}</span> |
                <strong>{{item.title}}</strong>
            </div>
            <time v-if="item.date" :datetime="timeSI" pubdate class="search-item__date d-block mb-2 mb-md-3">
                <span class="far fa-clock"></span>
                {{timeText}}
            </time>
            <div class="search-item__match">{{item.description}}</div>
        </router-link>
    </div>
</template>
<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    computed: {
        timeText: function() {
            return moment(this.item.date).format('DD/MM/YYYY')
        },
        timeSI: function() {
            return moment(this.item.date).format('YYYY-MM-DD hh:mm')
        },
    }
}
</script>
